import type { PropsWithChildren } from "react";

export const LeftSlot = ({ children }: Readonly<PropsWithChildren>) => (
  <div className="flex min-w-0 items-center" data-testid="header-v4-left-slot">
    {children}
  </div>
);

LeftSlot.displayName = "HeaderWrapper.LeftSlot";
